// src/pages/Contact.js
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { database } from "../firebaseConfig";
import { ref, get } from "firebase/database";
import ContactForm from "../components/ContactForm";
import "./Contact.css";
import { config } from '../config/config'
const API_URL = config.baseUrl;
export default function Contact() {
    const [result, setResult] = useState("");
    const [contactDetails, setContactDetails] = useState(null);

    useEffect(() => {
        const fetchContactDetails = async () => {
            try {
                const dbRef = ref(database, "floatingIconsConfig");
                const snapshot = await get(dbRef);
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    setContactDetails(data);
                } else {
                    console.log("No contact details found");
                }
            } catch (error) {
                console.error("Error fetching contact details:", error);
            }
        };

        fetchContactDetails();
    }, []);

    // Show loading indicator until data is fetched
    if (!contactDetails) {
        return (
            <div className="loading-container" style={{ width: "100%" }}>
                <img
                    src={`${API_URL}uploads/loading.gif`}
                    alt="Loading..."
                    className="loading-gif"
                    style={{ width: "100%" }}
                />
            </div>
        );
    }

    const onSubmit = async (formData, event) => {
        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: formData,
            });
            const data = await response.json();

            if (data.success) {
                setResult("Form Submitted Successfully our representative will reach out");
                event.target.reset();
            } else {
                console.log("Error", data);
                setResult(data.message);
            }
        } catch (error) {
            console.error("Submission error:", error);
            setResult("An error occurred, please contact us via phone call or WhatsApp");
        }
    };

    return (
        <div className="contactDetailsp-container">
            {/* Dynamic meta data via React Helmet */}
            <Helmet>
                <title>
                    {"Contact Us - Marriott Pharmaceutical"}
                </title>
                <meta
                    name="description"
                    content={
                        contactDetails.seo?.metaDescription
                    }
                />
                <meta
                    name="keywords"
                    content={
                        contactDetails.seo?.metaKeywords
                    }
                />
            </Helmet>

            <div className="contactDetailsp-content">
                {/* Left Column: Form and Contact Details */}
                <div className="contactDetailsp-left">
                    <h1>
                        Get <span>in Touch</span>
                    </h1>

                    {/* Render the inquiry form only if "inquire" has showOnContactPage true */}
                    {contactDetails.inquire && contactDetails.inquire.showOnContactPage ? (
                        <>
                            <p>
                                We’d love to hear from you! Fill out the form and our team will get back to you as soon as possible.
                            </p>
                            <ContactForm
                                formToken={contactDetails.inquire.formToken || ""}
                                onFormSubmit={onSubmit}
                                result={result}
                                setResult={setResult}
                            />
                            <span className="result-message">{result}</span>
                        </>
                    ) : null}

                    {/* Display Contact Details for all keys with showOnContactPage true */}
                    <div className="contactDetailsp-details">
                        <h2>Contact Details</h2>
                        <ul>
                            {Object.keys(contactDetails).map((key) => {
                                const detail = contactDetails[key];
                                if (!detail.showOnContactPage) return null;
                                return (
                                    <li key={key} className="contactDetailsp-detail-item">
                                        {key === "email" && <span>Email: {detail.address}</span>}
                                        {key === "inquire" && <span>Inquiry: {detail.recipientEmail}</span>}
                                        {key === "phone" && <span>Phone: {detail.number}</span>}
                                        {key === "whatsapp" && <span>WhatsApp: {detail.number}</span>}
                                    </li>
                                );
                            })}
                            {/* Social Media Links */}
                            {contactDetails.socialMedia && contactDetails.socialMedia.length > 0 && (
                                <li className="contactDetailsp-detail-item">
                                    <span>Social Media: </span>
                                    {contactDetails.socialMedia.map((social, idx) =>
                                        social.showOnContactPage ? (
                                            <a
                                                key={idx}
                                                href={social.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ marginRight: "10px" }}
                                            >
                                                <img
                                                    src={social.iconUrl}
                                                    alt={social.platform}
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        objectFit: "contain",
                                                        borderRadius: "50%"
                                                    }}
                                                />
                                            </a>
                                        ) : null
                                    )}
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                {/* Right Column: Image */}
                <div className="contactDetailsp-right">
                    <div className="contactDetailsp-image-container">
                        <img
                            src={contactDetails.inquire && contactDetails.inquire.imageUrl}
                            alt="Contact"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
